import api from '@/apis/di/purchasePurposeAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid CTMT
export const usePurchasePurposeComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onPurchasePurposeComboboxLoadData = (payload, row, column) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'purchase_purpose_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField);
  };

  // config columns combo
  const purchasePurposeComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã nhóm',
        dataField: 'purchase_purpose_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên nhóm',
        dataField: 'purchase_purpose_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'purchase_purpose_code',
    valueField: 'purchase_purpose_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onPurchasePurposeComboboxLoadData,
  };

  return {
    purchasePurposeComboConfig,
    onPurchasePurposeComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
